import React, { createContext } from "react";

const LocalizationContext = createContext(undefined);

const LocalizationProvider = ({ children, i18n }) => {

	return (
		<LocalizationContext.Provider value={i18n}>
			{children}
		</LocalizationContext.Provider>
	)
};

export { LocalizationProvider, LocalizationContext };